import React, {useState} from 'react';
import {useTheme} from "@mui/material/styles";
import {Box, Button, Divider, FormControl, Grid, IconButton, InputAdornment, Stack, Typography, useMediaQuery} from "@mui/material";
import AuthCardWrapper from "../AuthCardWrapper";
import Loader from "../../../utils/ui-components/Loader";
import {Link, useNavigate, useParams} from "react-router-dom";
import AuthRegister from "../auth-forms/auth-register";
import { Formik } from 'formik';
import * as Yup from 'yup';
import TextField from '../../../utils/ui-components/FormsUI/TextField';
import AnimateButton from '../../../utils/ui-components/AnimateButton';
import { openSuccessDialog } from '../../../utils/ui-components/pop-ups/SuccessDialog';
import * as api from "../../../assets/api/index";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {strengthColor, strengthIndicator} from "../../../utils/utils";



function ForgotPasswordChange() {
    const theme = useTheme();
    const {tocken} = useParams();
    const navigate = useNavigate()
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [strength, setStrength] = useState(0);
    const [level, setLevel] = useState({label: '', color: ''});

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event: any) => {
        event.preventDefault();
    };
    const changePassword = (value: any) => {
        const temp = strengthIndicator(value);
        setStrength(temp);
        setLevel(strengthColor(temp));
    };

    return (
        <Grid className="container">
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <AuthCardWrapper>
                    <Grid container spacing={2} alignItems="center" justifyContent="center">
                        <Grid item container spacing={2} sx={{mb: 1}} alignItems="center" justifyContent="center">
                            <Grid item>
                                <img
                                    // height="65"
                                    width="180"
                                    src={require("../../../assets/images/logo-with-name.png")}
                                    alt="logo"/>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid
                                container
                                direction={matchDownSM ? 'column-reverse' : 'row'}
                                alignItems="center"
                                justifyContent="center">
                                <Grid item>
                                    <Stack alignItems="center" justifyContent="center" spacing={1}>
                                        <Typography
                                            color={theme.palette.primary.main}
                                            gutterBottom
                                            variant={matchDownSM ? 'h3' : 'h2'}
                                        >
                                            Forgot Password
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            fontSize="16px"
                                            textAlign={matchDownSM ? 'center' : 'inherit'}
                                        >
                                           Enter your new password to continue
                                        </Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Formik
                                enableReinitialize={true}
                                initialValues={{
                                    password: '',
                                }}
                                validationSchema={Yup.object().shape({
                                    password: Yup.string().max(255).required('Password is required'),
                                })}
                                onSubmit={async (values, {setErrors, setStatus, setSubmitting} : any) => {
                                    try {
                                        if (values) {
                                                    setStatus({success: true});
                                                    setSubmitting(true);
                                                    const formData = {
                                                        token : String(tocken),
                                                        password : values.password
                                                    }
                            
                                                    const { data } = await api.changePassord(formData);
                            
                                                    openSuccessDialog(data.status, data.comment);
                                                    navigate("/login");
                                                }
                                            } catch (err: any) {
                                                setStatus({success: false});
                                                setErrors({submit: err.message});
                                                setSubmitting(false);
                                            }
                                        }}
                                >
                                {({errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values}: any) => (
                                <form noValidate onSubmit={handleSubmit}>
                                        <TextField
                                            fullWidth
                                            label="Password"
                                            name="password"
                                            type={showPassword ? 'text' : 'password'}
                                            value={values.password}
                                            onBlur={handleBlur}
                                            // onChange={handleChange}
                                            error={Boolean(touched.password && errors.password)}
                                            helperText={(touched.password && errors.password) && errors.password}
                                            InputProps={{
                                                endAdornment:(
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                            edge="end"
                                                            size="large"
                                                        >
                                                            {showPassword ? <Visibility/> : <VisibilityOff/>}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            inputProps={{}}
                                            onChange={(e : any) => {
                                                handleChange(e);
                                                changePassword(e.target.value);
                                            }}
                                        />
                                        {strength !== 0 && (
                                            <FormControl fullWidth>
                                                <Box sx={{mb: 2}}>
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item>
                                                            <Box
                                                                style={{backgroundColor: level?.color}}
                                                                sx={{width: 85, height: 8, borderRadius: '7px'}}
                                                            />
                                                        </Grid>
                                                        <Grid item>
                                                            <Typography variant="subtitle1" fontSize="0.75rem">
                                                                {level?.label}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </FormControl>
                                        )}
                                        <Box sx={{mt: 2}}>
                                            <AnimateButton>
                                                <Button
                                                    disableElevation
                                                    disabled={isSubmitting}
                                                    fullWidth
                                                    size="large"
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{color: "white", fontWeight: "bold"}}
                                                >
                                                Next
                                                </Button>
                                            </AnimateButton>
                                        </Box>
                                    </form>
                                )}
                            </Formik>

                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item>
                            <Grid item container direction="column" alignItems="center" xs={12}>
                                <Typography
                                    component={Link}
                                    to="/login"
                                    variant="subtitle1"
                                    sx={{textDecoration: 'none'}}
                                >
                                    Back to login
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </AuthCardWrapper>
            </Grid>
            {loading && <Loader/>}
        </Grid>
    );
}

export default ForgotPasswordChange;